/* ============================================================
   Offe Market - category row arrows.

   The rail is a plain overflow scroller, so touch, trackpad,
   shift+wheel and keyboard already work with no script. This
   only adds the arrows and keeps them honest: each hides when
   there is nothing further that way, and both hide when the row
   already fits. Nothing here is required for the row to work.

   A custom element so sections added or reordered in the theme
   editor wire themselves up without a reload.
   ============================================================ */

if (!customElements.get('category-row')) {
  customElements.define(
    'category-row',
    class CategoryRow extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.category-row__rail');
        this.prev = this.querySelector('.category-row__arrow--prev');
        this.next = this.querySelector('.category-row__arrow--next');
        if (!this.rail) return;

        this.update = this.update.bind(this);

        if (this.prev) this.prev.addEventListener('click', () => this.page(-1));
        if (this.next) this.next.addEventListener('click', () => this.page(1));
        this.rail.addEventListener('scroll', this.update, { passive: true });

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.rail);
        } else {
          window.addEventListener('resize', this.update);
        }

        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.update);
      }

      page(direction) {
        var card = this.rail.querySelector('.category-row__item');
        var gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        var step = card ? card.getBoundingClientRect().width + gap : this.rail.clientWidth * 0.8;
        // move a whole viewport of cards, but always at least one
        var perPage = Math.max(1, Math.floor(this.rail.clientWidth / step));
        this.rail.scrollBy({ left: direction * step * perPage, behavior: 'smooth' });
      }

      update() {
        var max = this.rail.scrollWidth - this.rail.clientWidth;
        var x = this.rail.scrollLeft;
        // rtl reports scrollLeft as negative or reversed; abs covers both
        var pos = Math.abs(x);
        var scrollable = max > 2;
        if (this.prev) this.prev.hidden = !scrollable || pos <= 2;
        if (this.next) this.next.hidden = !scrollable || pos >= max - 2;
      }
    }
  );
}
